<div class="footer">
  <div class="footer__content">
    <div>
      <a *ngFor="let item of DOCS | keyvalue" target="_blank" [href]="item.value">{{ item.key }}</a>
    </div>
    <button class="report_btn" (click)="showReportForm()">Report Problem</button>
  </div>
</div>
